import React from 'react';
import { useSymbolPrices } from '../../../context/WebSocketContext';

export default function PercentageChange({ symbolId }) {
    const { [symbolId]: symbol } = useSymbolPrices();

    if (!symbol || !symbol.open) return <span>--</span>;

    const percentageChange = ((symbol.bid - symbol.open) / symbol.open * 100).toFixed(2);
    const color = percentageChange < 0 ? "#da5244" : "#3687ed";

    return <span className={`${percentageChange > 0 ? 'green' : 'red'} `}>{percentageChange}%</span>;
}
